import { useState } from "react";
import { categories, featuredComics, latestComics } from "@/mocks/homeData";
import ComicCard from "./ComicCard";

const allComics = [...featuredComics, ...latestComics];

export default function Categories() {
  const [active, setActive] = useState("all");

  const list =
    active === "all"
      ? allComics
      : allComics.filter((c) => c.category === active);

  return (
    <section
      id="categories"
      className="w-full bg-background-100 py-14 md:py-20"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <span className="text-sm font-bold text-accent-600">
            按题材挑选，总有一篇合你胃口
          </span>
          <h2 className="font-heading mt-2 text-2xl text-foreground-950 md:text-4xl">
            题材分类
          </h2>
          <p className="mt-2 text-sm text-foreground-700 md:text-base">
            脑洞、反转、治愈、搞笑、科幻、奇谭——六大门类，覆盖你想不到的创意短篇漫画。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {categories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              onClick={() => setActive(cat.key)}
              className={`group flex flex-col items-start gap-1 rounded-xl p-4 text-left transition-colors ${
                active === cat.key
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-200 bg-background-50 hover:border-primary-200 hover:bg-primary-50"
              }`}
            >
              <i
                className={`${cat.icon} text-xl ${
                  active === cat.key ? "text-background-50" : "text-primary-600"
                }`}
              />
              <span className="mt-2 text-sm font-bold">{cat.name}</span>
              <span
                className={`text-xs ${active === cat.key ? "text-background-50/80" : "text-foreground-500"}`}
              >
                {cat.count} 篇
              </span>
            </button>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => setActive("all")}
            className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-bold transition-colors ${
              active === "all"
                ? "bg-foreground-950 text-background-50"
                : "bg-background-50 text-foreground-700 hover:bg-secondary-100"
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              onClick={() => setActive(cat.key)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-bold transition-colors ${
                active === cat.key
                  ? "bg-foreground-950 text-background-50"
                  : "bg-background-50 text-foreground-700 hover:bg-secondary-100"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        {list.length > 0 ? (
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {list.map((c) => (
              <ComicCard key={c.id} comic={c} />
            ))}
          </div>
        ) : (
          <p className="mt-6 rounded-xl border border-background-200 bg-background-50 p-8 text-center text-sm text-foreground-600">
            这个题材的新作品正在路上，先去看看其他分类吧～
          </p>
        )}
      </div>
    </section>
  );
}